import React from "react";

const Consent = () => {
  return (
    <div>
      <h1>Consent</h1>
    </div>
  );
};

export default Consent;
